import script from "./TransactionsList.vue?vue&type=script&setup=true&lang=js"
export * from "./TransactionsList.vue?vue&type=script&setup=true&lang=js"

import "./TransactionsList.vue?vue&type=style&index=0&id=79ca974a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79ca974a"]])

export default __exports__